import { serviceIcon, Check, Bolt } from './Icons';

export default function DigitalTools({ services }) {
  const tools = (services || []).filter((s) => s.category === 'digital-tool');
  if (tools.length === 0) return null;

  return (
    <section className="section section--tools" id="tools">
      <div className="container">
        <div className="section__head">
          <span className="eyebrow eyebrow--accent">
            <Bolt width={14} height={14} /> The Thunder ecosystem
          </span>
          <h2 className="section__title">Subscription-gated digital tools</h2>
          <p className="section__sub">
            Beyond installations, we&rsquo;re building a growing suite of self-serve tools you can
            run on demand — pay-as-you-grow, no hardware required.
          </p>
        </div>

        <div className="grid grid--2">
          {tools.map((t) => {
            const Icon = serviceIcon(t);
            return (
              <article key={t.slug || t.title} className="card tool-card">
                <div className="tool-card__top">
                  <div className="tool-card__icon">
                    <Icon width={28} height={28} />
                  </div>
                  <span className="badge">Coming soon</span>
                </div>
                <h3 className="tool-card__title">{t.title}</h3>
                <p className="tool-card__summary">{t.summary}</p>
                {Array.isArray(t.features) && t.features.length > 0 && (
                  <ul className="tool-card__features">
                    {t.features.map((f) => (
                      <li key={f}>
                        <Check width={15} height={15} /> {f}
                      </li>
                    ))}
                  </ul>
                )}
                <a href="#contact" className="btn btn--sm btn--outline">
                  Join the waitlist
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
